import styled from 'styled-components';

const Container = styled.div.withConfig({
  componentId: 'button_container',
})`
  border-radius: 4px;
  padding: 4px;
  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  &:hover {
    transform: scale(1.05);
  }
  &:active {
    transform: scale(0.95);
  }

  transition:
    background 0.2s linear,
    transform 0.2s linear;

  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ButtonStyle = { Container };
